import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-phone-input-dialog',
  templateUrl: './phone-input-dialog.component.html'
})
export class PhoneInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editPhoneInputForm: UntypedFormGroup;
  status: boolean;
  control: FieldConfigName;
  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<PhoneInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this.validateFormBuilder();
    this.editProperty(this.control);
  }

  validateFormBuilder(): void {
    this.editPhoneInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false]
    });
  }

  editProperty(control: any): void {
    this.status = control.options.isRequired;
    this.editPhoneInputForm.setValue({
      tooltip: control.options.tooltip || '',
      label: control.options.label,
      placeholder: control.options.placeholder || '',
      isRequired: control.options.isRequired
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editPhoneInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editPhoneInputForm.value);
  }

  onChange(event: any): void {
    this.status = !!event.checked;
  }
}
